package com.essntl.core.settings.data.supabase.feature

import com.essntl.core.settings.domain.model.feature.FeatureModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class FeatureDto(
    val id: String,
    val name: String,
    @SerialName("created_at")
    val createdAt: String,
) {
    fun toModel() =
        FeatureModel(
            id = id,
            name = name,
            createdAt = createdAt,
        )
}